<template>
    <b-modal v-model="modalAberto" size="lg" :title="title" hide-footer @hidden="fecharModal">
        <b-table :items="itens" :fields="fields" responsive :busy="this.busy">
            <template #cell(consulta)="data">
                <b-button variant="link" class="d-flex align-items-center">
                    <b-icon icon="search" @click="mostrarDescricaoDetalhada(data.item.id)"></b-icon>
                </b-button>
            </template>
            <template #cell(item)="data">
                {{ data.item.apelido }}
            </template>
            <template #cell(quantidade)="data">
                <b-form-input type="number" v-model="data.item.quantidade" min="1" class="w-30"
                    style="font-size:10px;height:20px;" />
            </template>
            <template #cell(valorUnitario)="data">
                {{ formatCurrency(data.item.valorUnitario) }}
            </template>
            <template #cell(acao)="data">
                <div class="d-flex justify-content-center align-items-center">
                    <b-button variant="danger" @click="removerItem(data.item)" pill size="sm">
                        <b-icon icon="x"></b-icon>
                    </b-button>
                </div>
            </template>
        </b-table>

        <!-- Resumo do Pedido -->
        <b-row class="mt-3">
            <b-col class="text-right">
                <div class="h6">Valor Total Estimado: {{ formatCurrency(valorTotal) }}</div>
            </b-col>
        </b-row>

        <!-- Campo de Justificativa -->
        <b-form-group label="Justificativa" class="mt-3">
            <b-form-textarea v-model="justificativa" required></b-form-textarea>
        </b-form-group>

        <!-- Rodapé com Botões de Ação -->
        <b-row class="mt-3">
            <b-col class="text-right">
                <b-button variant="secondary" @click="adicionarItens" class="mr-2">
                    <b-icon icon="arrow-left-circle"></b-icon> Adicionar + itens
                </b-button>
                <b-button variant="primary" @click="enviarPedido">
                    <b-icon icon="arrow-right-circle"></b-icon> Enviar pedido
                </b-button>
            </b-col>
        </b-row>

        <!-- Modal de Descrição Detalhada do Produto -->
        <DescricaoDetalhadaProduto v-if="showModalDescricaoDetalhada" :mostrarDetalhes='false' :id="produtoId"
            @fecharModal="fecharModalDescricaoDetalhada" :prefix="prefix + title + ' > '" />
    </b-modal>
</template>

<script>
import ResourceService from "@/core/api/ResourceService"
import ConfirmMixin from "@/core/mixins/confirm"
import API from "@/core/api"
import ConfiguracaoSistemaEnum from "@/core/utils/ConfiguracaoSistemaEnum"
import DescricaoDetalhadaProduto from './DescricaoDetalhadaProduto.vue'

export default {
    components: {
        DescricaoDetalhadaProduto
    },
    props: {
        itens: {
            type: Array,
            required: true
        },
        prefix: {
            type: String,
            default: "",
        },
        title: {
            type: String,
            default: "Carrinho"
        }
    },
    mixins: [ConfirmMixin],
    data() {
        return {
            busy: false,
            modalAberto: true,
            justificativa: '',
            showModalDescricaoDetalhada: false,
            produtoId: null,
            fields: [
                { key: 'consulta', label: '', tdClass: 'w-1 align p-2' },
                { key: 'item', label: 'Item', tdClass: 'p-2', class: 'align-middle' },
                { key: 'quantidade', label: 'Quantidade', tdClass: 'p-2', class: 'quantidade-column align-middle' },
                { key: 'valorUnitario', label: 'Valor Unitário', tdClass: 'p-2', class: 'align-middle' },
                { key: 'acao', label: 'Ação', tdClass: 'w-1 align-middle' },
            ],
        }
    },
    beforeMount() {
        this.$service = new ResourceService(`/api/pedidosprodutocatalogo`)
    },
    computed: {
        valorTotal() {
            return this.itens.reduce((total, item) => total + item.quantidade * item.valorUnitario, 0)
        }
    },
    methods: {
        formatCurrency(value) {
            return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value)
        },
        removerItem(item) {
            this.$emit('removerItem', item)
        },
        async enviarPedido() {
            if (!this.justificativa) {
                this.$notify({
                    message: 'A justificativa é obrigatória',
                    type: 'danger',
                })
                return
            }
            if (this.itens.length === 0) {
                this.$notify({
                    message: 'A lista de itens não pode estar vazia',
                    type: 'danger',
                });
                return;
            }
            try {
                const response = await API.get(`/api/configuracoes-sistema/propriedade/${ConfiguracaoSistemaEnum.CONFIG_EMAIL_DESTINATARIO_CONFIRMACAO_PEDIDO_CATALOGO.nomeConfiguracaoSistema}`)
                const configuracao = response.data
                let mensagem = 'Deseja finalizar e enviar seu pedido agora?'
                if (configuracao.valorPropriedade == null || configuracao.valorPropriedade === '') {
                    mensagem = 'Não possui um destinatário configurado para receber a confirmação do Pedido. Deseja finalizar e enviar seu pedido agora?'
                }
                const confirmado = await this.$confirm(mensagem)
                if (confirmado) {
                    await this.criarPedido()
                    this.fecharModal()
                    this.$emit('limparCarrinho')
                }
            } catch (error) {
                this.$notify({
                    message: 'Erro ao enviar o pedido',
                    type: 'danger',
                })
            }
        },
        async criarPedido() {
            const pedido = {
                justificativa: this.justificativa,
                itens: this.itens.map(item => ({
                    idProduto: item.id,
                    produtoCatalogo: item.produtoCatalogo,
                    quantidadePedida: item.quantidade,
                    valorUnitario: item.valorUnitario,
                    atendido: false
                }))
            }
            this.busy = true;
            await this.$service.save(pedido)
            this.$notify({
                message: 'Pedido enviado com sucesso',
                type: 'success',
            });
            this.busy = false;
        },
        adicionarItens() {
            this.fecharModal()
        },
        fecharModal() {
            this.$emit('fecharModal')
        },
        mostrarDescricaoDetalhada(id) {
            this.produtoId = id
            this.showModalDescricaoDetalhada = true
        },
        fecharModalDescricaoDetalhada() {
            this.showModalDescricaoDetalhada = false
        }
    }
}
</script>

<style scoped>
.acao-column {
    width: 50px;
    text-align: center;
}

.cursor-pointer {
    cursor: pointer;
}
</style>
